exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-tagsinput{background-color:#fff;border:1px solid #ccc;padding-left:5px;padding-top:5px}.react-tagsinput--focused{border-color:rgba(0,120,231,.5)}.react-tagsinput-tag{background-color:rgba(0,120,231,.5);border-radius:3px;color:#fff;display:inline-block;font-family:sans-serif;font-size:13px;font-weight:400;margin-bottom:5px;margin-right:5px;padding:5px}.react-tagsinput-remove{cursor:pointer;font-weight:700}.react-tagsinput-tag a:before{content:\" \\D7\"}.react-tagsinput-input{background:transparent;border:0;color:#777;font-family:sans-serif;font-size:13px;font-weight:400;margin-bottom:6px;margin-top:1px;outline:none;padding:5px;width:80px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/main/stylesheets/react-tagsinput.css
 ** module id = 754
 ** module chunks = 0
 **/